import type { FC } from 'react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { format } from 'date-fns';
import { useFormikContext } from 'formik';

import type { FormFieldKeys } from '../constants';
import FollowUpInput from '../FollowUpInput';

interface FirstContactAtInputProps {
  disabled?: boolean;
}

const FirstContactAtInput: FC<FirstContactAtInputProps> = ({
  disabled = false,
}) => {
  const { t } = useTranslation('followUp');
  const { values, errors, touched, handleChange, initialValues } =
    useFormikContext<FormFieldKeys>();

  const date = useMemo(() => {
    const fromValues = new Date(values.firstContactAt ?? '');
    // If invalid, default to initial date to avoid a crash when formatting.
    // The date can be invalid if the user clears the input.
    const unformattedDate = isNaN(fromValues.getDate())
      ? initialValues.firstContactAt
        ? new Date(initialValues.firstContactAt)
        : new Date()
      : fromValues;

    return format(unformattedDate, 'yyyy-MM-dd');
  }, [initialValues.firstContactAt, values.firstContactAt]);

  return (
    <FollowUpInput
      disabled={disabled}
      label={t('followUpCall.firstContactAt')}
      name="firstContactAt"
      sx={{
        display: values.callHappened ? 'flex' : 'none',
        gap: 1,
        alignItems: 'start',
      }}
      errorMessage={
        !!errors.firstContactAt &&
        !!touched.firstContactAt &&
        errors.firstContactAt
      }
    >
      <TextField
        disabled={disabled}
        id="firstContactAt"
        name="firstContactAt"
        value={date}
        onChange={handleChange}
        type="date"
      />
    </FollowUpInput>
  );
};

export default FirstContactAtInput;
